import React, { useState, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import UserGridDetails from "./userGridDetails";
import classes from './SalesPersonGrid.module.css'
import Button from "../Button";

const TableGrid = ({
  salesPersonsData,
  setSalesPersonsData,
  setPageNumber,
  pageNumber,
  isPrevious,
  isNext,
  isLoading,
  onFetchData
}) => {
  const [showCustomData, setShowCustomData] = useState(false);
  const [userDetails, setUserDetails] = useState();

  const onCellClicked = (event) => {
    const eventData = event?.data;
    setShowCustomData(true);
    setUserDetails({ ...userDetails, eventData });
  };

  const onNext = () => {
    setPageNumber((previous) => previous + 1);
    setShowCustomData(false);
    setSalesPersonsData([]);
  };

  const onPrevious = () => {
    setPageNumber((previous) => previous - 1);
    setShowCustomData(false);
    setSalesPersonsData([]);
  };

  const closeUserDetails = () => {
    setShowCustomData(false);
  };

  const columnDefs = useMemo(() => [
    {
      field: "id",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,
      headerName: "S No",
    },
    { field: "empCode" },
    { field: "empName" },
    { field: "empEmail" },
    { field: "empPhoneNumber" },
    { field: "userId" },
  ]);

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      flex: 1,
    }),
    []
  );

  return (
    <div className={"ag-theme-alpine " + classes["ag-grid-height"]}>
      <AgGridReact
        onCellClicked={(e) => onCellClicked(e)}
        rowData={salesPersonsData}
        columnDefs={columnDefs}
        rowSelection="multiple"
        animaterowData={true}
        suppressPaginationPanel={true}
        overlayNoRowsTemplate={`<span style="padding: 10px; border: var(--ag-borders) var(--ag-border-color); background: var(--ag-background-color); border-radius: var(--ag-card-radius); box-shadow: var(--ag-card-shadow);padding: var(--ag-grid-size); ">
          ${!isLoading ? "" : "No Data."}</span>`}
        suppressScrollOnNewData={true}
        defaultColDef={defaultColDef}
      />
      <div className="flex justify-center items-center mt-3">
        <Button disabled={!isPrevious} onClick={() => onPrevious()}>
          Previous
        </Button>
        <p className="mx-2">Page: {pageNumber + 1}</p>
        <Button disabled={!isNext} onClick={() => onNext()}>
          Next
        </Button>
      </div>
      {showCustomData && (
        <UserGridDetails
          userDetails={userDetails}
          closeUserDetails={(data) => {
            data?.fetchData && onFetchData && onFetchData();
            closeUserDetails();
          }}
        />
      )}
    </div>
  );
};

export default TableGrid;
